import {MaterialReactTable, MRT_EditActionButtons, useMaterialReactTable} from "material-react-table";
import {Button, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {useContext, useState} from "react";
import {store} from "../../../Store/store";
import {HARDWARE_CATALOG_ADMIN} from "../../../Constants/constants";

const CatalogTable = ({
                          columns,
                          fetchedEntities,
                          isLoadingEntities,
                          isLoadingEntitiesError,
                          isFetchingEntities,
                          isCreatingEntity,
                          isUpdatingEntity,
                          isDeletingEntity,
                          handleCreateEntity,
                          handleSaveEntity,
                          handleCustomSaveEntity,
                          renderCustomAction,
                          openDeleteConfirmModal,
                          setValidationErrors,
                          entityName,
                          setGlobalFilter,
                          setPagination,
                          setSorting,
                          columnFilters,
                          globalFilter,
                          pagination,
                          sorting,
                          totalElements,
                          customEditDialog,
                          customCreateDialog,
                          validationErrors,
                          customViewDialog,
                          setColumnFilters
                      }) => {
    const globalStateObj = useContext(store);
    const isHwCatalogAdmin = globalStateObj.state.userRole === HARDWARE_CATALOG_ADMIN;
    const [viewRow, setViewRow] = useState(null);

    const openViewDialog = (row) => {
        setViewRow(row);
    };

    const table = useMaterialReactTable({
        columns: columns,
        defaultColumn: {size: 5},
        manualFiltering: true,
        initialState: {showColumnFilters: false, density: 'compact'},
        manualPagination: true,
        manualSorting: true,
        data: fetchedEntities,
        createDisplayMode: 'modal',
        editDisplayMode: 'modal',
        enableEditing: true,
        enableGlobalFilter: false,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        getRowId: (row) => row.id,
        rowCount: totalElements,
        muiToolbarAlertBannerProps: isLoadingEntitiesError
            ? {
                color: 'error',
                children: 'Error loading data',
            }
            : undefined,
        muiTableContainerProps: {
            sx: {
                height: '65.5vh'
            },
        },
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onCreatingRowCancel: () => setValidationErrors({}),
        onCreatingRowSave: handleCustomSaveEntity ? handleCustomSaveEntity : handleCreateEntity,
        onEditingRowCancel: () => setValidationErrors({}),
        onEditingRowSave: handleCustomSaveEntity ? handleCustomSaveEntity : handleSaveEntity,
        renderCreateRowDialogContent: ({table, row, internalEditComponents}) => {
            return customCreateDialog ? customCreateDialog(table, row, internalEditComponents, validationErrors, setValidationErrors, "create") :
                (
                    <>
                        <DialogTitle variant="h4">{`Create a New ${entityName}`}</DialogTitle>
                        <DialogContent sx={{overflowY: 'auto'}}>
                            <Grid container spacing={2}>
                                {internalEditComponents.map((component, index) => (
                                    <Grid item xs={12} key={index}>
                                        {component}
                                    </Grid>
                                ))}
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <MRT_EditActionButtons variant="text" table={table} row={row}/>
                        </DialogActions>
                    </>)
        },
        renderEditRowDialogContent: ({table, row, internalEditComponents}) => {
            return customEditDialog ? customEditDialog(table, row, internalEditComponents, validationErrors, setValidationErrors, "edit") :
                (
                    <>
                        <DialogTitle variant="h4">{`Edit ${entityName}`}</DialogTitle>
                        <DialogContent
                            sx={{overflowY: 'auto'}}
                        >
                            <Grid container spacing={2}>
                                {internalEditComponents.map((component, index) => (
                                    <Grid item xs={12} key={index}>
                                        {component}
                                    </Grid>
                                ))}
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <MRT_EditActionButtons variant="text" table={table} row={row}/>
                        </DialogActions>
                    </>
                )
        },
        renderRowActions: ({row, table}) => (
            <Grid container spacing={0} alignItems="center" wrap="nowrap">
                {renderCustomAction ? (
                    <Grid item>
                        {renderCustomAction()}
                    </Grid>
                ) : null}
                <Grid item>
                    <Tooltip title="View">
                        <IconButton onClick={() => openViewDialog(row)}>
                            <VisibilityIcon/>
                        </IconButton>
                    </Tooltip>
                </Grid>
                {isHwCatalogAdmin ? (
                    <>
                        <Grid item>
                            <Tooltip title="Edit">
                                <IconButton onClick={() => table.setEditingRow(row)}>
                                    <EditIcon/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            <Tooltip title="Delete">
                                <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
                                    <DeleteIcon/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </>
                ) : null}
            </Grid>

        ),
        renderTopToolbarCustomActions: ({table}) => (
            isHwCatalogAdmin ?
                <Button
                    sx={{textTransform: 'none'}}
                    variant="contained"
                    onClick={() => {
                        table.setCreatingRow(true);
                    }}
                >
                    {`Create a new ${entityName}`}
                </Button>
                : null
        ),
        state: {
            isLoading: isLoadingEntities,
            isSaving: isCreatingEntity || isUpdatingEntity || isDeletingEntity,
            showAlertBanner: isLoadingEntitiesError,
            showProgressBars: isFetchingEntities,
            pagination: pagination,
            columnFilters: columnFilters,
            globalFilter: globalFilter,
            sorting: sorting,
        },
    });

    return (
        <>
            <MaterialReactTable table={table}/>
            {viewRow && customViewDialog(columns, viewRow, setViewRow)}
        </>
    )
}

export default CatalogTable;
